import { types } from '../actions/types';

export const ColorReducer = (
  state = {
    get: null,
    create: null,
    update: null,
    deleteById: null,
  },
  action,
) => {
  switch (action.type) {
    case types.cmGetColors:
      return { ...state, get: action.payload };
    case types.cmCreateColor:
      return { ...state, create: action.payload };
    case types.cmUpdateColor:
      return { ...state, update: action.payload };
    case types.cmDeleteColorById:
      return { ...state, deleteById: action.payload };
    default:
      return state;
  }
};
